import { Component, inject, OnInit } from '@angular/core';
import { CoreModule, emailValidator, FormComponent } from '@toevla-webapplications/core';
import { FormArray, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BookingService } from '../../../../../../services/booking/booking.service';
import { ToastsService } from '../../../../../../services/toasts/toasts.service';

@Component({
    selector: 'ivva-booking-oh-contacts',
    templateUrl: './booking-oh-contacts.component.html',
    styleUrls: ['./booking-oh-contacts.component.scss'],
    imports: [ReactiveFormsModule, CoreModule, TranslateModule]
})
export class BookingOhContactsComponent extends FormComponent implements OnInit {
	private readonly bookingService = inject(BookingService);
	private readonly fb = inject(FormBuilder);
	private readonly toastsService = inject(ToastsService);

	get guide(): FormArray {
		return this.form?.get('guide') as FormArray;
	}

	get other(): FormArray {
		return this.form?.get('other') as FormArray;
	}

	ngOnInit() {
		const data = this.bookingService.getCurrentBooking();
		const guide =
			data.guide?.map((g) =>
				this.fb.group({
					name: [`${g?.firstName} ${g?.lastName}`],
					bookingConfirmations: [g?.bookingConfirmations || false],
				})
			) || [];

		this.form = this.fb.group({
			booker: this.fb.group({
				name: [`${data.booker?.firstName} ${data.booker?.lastName}`],
				bookingConfirmations: [data.booker?.bookingConfirmations || false],
			}),
			guide: this.fb.array(guide),
			other: this.fb.array([]),
		});

		data.other?.forEach((fm: any) => {
			this.addOther(fm);
		});
	}

	addOther(o?: any) {
		const other = this.fb.group({
			fullName: [o?.fullName, Validators.required],
			email: [o?.email, [Validators.required, emailValidator]],
		});

		this.other.push(other);
	}

	removeOther(index: number) {
		this.other.removeAt(index);
	}

	override getFormData(): any {
		const data = super.getFormData();
		const booking = this.bookingService.getCurrentBooking();

		return {
			booker: {
				...booking.booker,
				bookingConfirmations: data.booker.bookingConfirmations || false,
			},
			guide:
				booking.guide?.map((g, index) => {
					return {
						...g,
						bookingConfirmations: data.guide[index].bookingConfirmations || false,
					};
				}) || [],
			other: data.other,
		};
	}

	override isFormValid(triggerErrors: boolean = true): boolean {
		const valid = super.isFormValid(triggerErrors);

		if (valid) {
			const data = this.form.value;
			const confirmations = [data.booker.bookingConfirmations, ...data.guide.map((g: any) => g.bookingConfirmations)];
			const atleastOne = confirmations.some((confirmation) => confirmation);

			if (atleastOne) {
				return true;
			}

			this.toastsService.error('BOOKING.OH_CONTACTS.ATLEAST_ONE_ERROR');
		}

		return false;
	}
}
